import React from "react";
import PropTypes from "prop-types";
import WysiwygStyle from "theme/modules/WysiwygV2/Style";

/**
 * @type {React.FC<StyleProps>}
 */
const Style = ({ children }) => {
  return <WysiwygStyle rootSelector="#html-body">{children}</WysiwygStyle>;
};

/**
 * @typedef StyleProps
 * @property {React.ReactNode} children
 */
Style.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Style;
